import { Card, CardContent, Grid } from "@mui/material";
import React, { useState } from "react";
import Sidebar from './profileComponents/SideBar';
import FormAddress from './profileComponents/FormAddress';
import FormInstitution from "./profileComponents/FormInstitution";
import FormChangePassword from "./profileComponents/FormChangePassword";
import ListProject from "./profileComponents/ListProject";
import UserActiveProfiles from "./profileComponents/UserActiveProfiles";
import ListPublish from "app/views/profile/profileComponents/ListPublish";
import  * as storage  from "app/data/storage";



const UserProfileInfo = ({ profilesData, listProfiles }) => {
  const initialItem = storage.get('role') === 'GUEST' ? 'profileSelect' : 'profileUserAddress'
  const [selectedProfileItem, setSelectedProfileItem] = useState<string>(initialItem)
  
  return (
    <Card>
      <CardContent>
        <Grid container>

            {/* SIDEBAR LATERAL */}
            <Grid item sm={3} xs={12} py={2} mr={2}
            sx={{
              borderRadius: '8px', // Adiciona bordas arredondadas
              overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
              border: '1px solid #ddd', // Adiciona uma borda para visualização 
              minHeight: 0,
              height: '100%'
            }}>
                <Sidebar setSelectedProfileItem={setSelectedProfileItem} selectedProfileItem={selectedProfileItem}/>
            </Grid>

            {/* STATUS DO PERFIL */}
            <Grid item sm={8} xs={12}>
              {/* <Grid item sm={12} xs={12} 
                sx={{
                  borderRadius: '8px', // Adiciona bordas arredondadas
                  overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
                  border: '1px solid #ddd', // Adiciona uma borda para visualização
              }}>
                <Container>
                  <H1 sx={{}}>Status do Perfil</H1>
                  <Typography variant="body2" color="text.secondary">
                    Progresso: {progress}%
                  </Typography>
                  <LinearProgress variant="determinate" value={progress} sx={{padding: '5px 5px', margin: '10px 10px 10px 0px', width: '50%' }} />
                </Container>
              </Grid> */}

              {/* GRID DOS FORMS */}
              {selectedProfileItem === 'profileSelect' && (
                <Grid item sm={12} xs={12} 
                  sx={{
                    borderRadius: '8px', // Adiciona bordas arredondadas
                    overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
                    border: '1px solid #ddd', // Adiciona uma borda para visualização
                  }}>
                  {/* <UserProfileList profiles={profilesData} listProfiles={listProfiles} /> */}
                  <UserActiveProfiles profiles={profilesData.data.response} setSelectedProfileItem={setSelectedProfileItem}/>
                </Grid>
              )}

              {selectedProfileItem === 'profileUserAddress' && (
                <Grid item sm={12} xs={12}
                  sx={{
                    borderRadius: '8px', // Adiciona bordas arredondadas
                    overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
                    border: '1px solid #ddd', // Adiciona uma borda para visualização
                  }}>
                  <FormAddress />
                </Grid>
              )}

              {selectedProfileItem === 'profileInstituition' && (
                <Grid item sm={12} xs={12}
                  sx={{
                    borderRadius: '8px', // Adiciona bordas arredondadas
                    overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
                    border: '1px solid #ddd', // Adiciona uma borda para visualização
                  }}>
                  <FormInstitution />
                </Grid>
              )}

              {selectedProfileItem === 'profileProject' && (
                <Grid item sm={12} xs={12}
                  sx={{
                    borderRadius: '8px', // Adiciona bordas arredondadas
                    overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
                    border: '1px solid #ddd', // Adiciona uma borda para visualização
                  }}>
                  <ListProject />
                </Grid>
              )}

              {selectedProfileItem === 'profilePublish' && (
                <Grid item sm={12} xs={12}
                  sx={{
                    borderRadius: '8px', // Adiciona bordas arredondadas
                    overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
                    border: '1px solid #ddd', // Adiciona uma borda para visualização
                  }}>
                  <ListPublish/>
                </Grid>
              )}

              {selectedProfileItem === 'profileChangePassword' && (
                <Grid item sm={12} xs={12}
                  sx={{
                    borderRadius: '8px', // Adiciona bordas arredondadas
                    overflow: 'hidden', // Garante que o conteúdo se ajuste às bordas
                    border: '1px solid #ddd', // Adiciona uma borda para visualização
                  }}>
                  <FormChangePassword />
                </Grid>
              )}

              
            </Grid>
            
        </Grid>
      </CardContent>
    </Card>

  )

}

export default UserProfileInfo